import Keycloak from 'keycloak-js';
import { getEnvironmentVar } from '../getEnvironmentVar';

const keycloak = new Keycloak({
  clientId: 'mandant-configuration-client',
  realm: getEnvironmentVar('REACT_APP_KEYCLOAK_REALM'),
  url: getEnvironmentVar('REACT_APP_KEYCLOAK_URL')
});

export default keycloak;
